import React from 'react';

import { flagStyles } from '../settings';

const SvgVI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5664px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVI;
